import React from 'react'
import { getImportanceColor } from '../../utils/color'
import {
  Box,
  Button,
  CircularProgress,
  Typography,
  colors,
} from '@mui/material'
import { addTimezoneOffsetToTimestamp } from '../../utils/date'
import { Link } from '@mui/icons-material'

export const Tag = ({ backgroundColor, children, borderColor }) => {
  return (
    <Box
      sx={{
        mr: 2,
        py: 1,
        px: 2,
        borderRadius: '6px',
        backgroundColor,

        border: `2px solid ${borderColor}`,
      }}
    >
      {children}
    </Box>
  )
}

const CustomerHeader = ({
  customer,
  customerStatusTypesData,
  customerTicketsQuery,
  tasks = [],
  types,
  Icon,
  tooltip,
  customerContacts = [],
  showContact,
  openContact,
}) => {
  if (!customer) return <CircularProgress />

  const customerStatusTypes = customerStatusTypesData?.customerStatusTypes || []
  const customerStatusType = customerStatusTypes.find(
    (t) => t.id === customer?.statusTypeId
  )
  const importanceType =
    types?.importanceTypes?.find(({ id }) => customer.importanceTypeId === id)
      ?.name || ''

  const hasOpenTicket =
    !customerTicketsQuery.isLoading &&
    customerTicketsQuery.tickets.some(
      (ticket) => !ticket.closedOn && ticket?.statusTypeId !== 3
    )

  const today = addTimezoneOffsetToTimestamp(new Date())

  const hasOpenTask = tasks.some((t) => !t.completedOn)

  const hasOverDueTask = tasks.some((t) => {
    const dueDate = new Date(t.date)
    return dueDate < today && !t.completedOn
  })

  const contact =
    customerContacts.find((c) => c.isDefault) || customerContacts[0]

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography variant='h4' sx={{ my: 2, mr: 1 }}>
          <b>{customer.name || 'New account'}</b>
        </Typography>
        {Icon && (
          <Icon
            sx={{ width: '32px', height: '32px', ml: 1 }}
            color={'primary'}
          />
        )}
        {tooltip && tooltip}
      </Box>
      <Box sx={{ mb: 2, mt: -2 }}>
        {showContact && contact && (
          <Button
            endIcon={<Link />}
            onClick={() => {
              openContact()

              setTimeout(() => {
                const el = document.getElementById('contacts-header')
                if (el)
                  el.scrollIntoView({ behavior: 'smooth', block: 'start' })
              }, 200)
            }}
          >
            {contact.firstName + ' ' + contact.lastName}
          </Button>
        )}
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        {importanceType !== 'Normal' && (
          <Tag
            backgroundColor={getImportanceColor(
              customer.importanceTypeId,
              true
            )}
            borderColor={getImportanceColor(
              customer.importanceTypeId,
              false,
              true
            )}
          >
            {importanceType}
          </Tag>
        )}
        {customerStatusType && (
          <Tag
            backgroundColor={colors[customerStatusType.color][100]}
            borderColor={colors[customerStatusType.color][400]}
          >
            {customerStatusType.name}
          </Tag>
        )}

        {hasOpenTicket && (
          <Tag backgroundColor={colors.red[100]} borderColor={colors.red[400]}>
            {'Open Ticket'}
          </Tag>
        )}

        {hasOpenTask && !hasOverDueTask && (
          <Tag
            backgroundColor={colors.orange[100]}
            borderColor={colors.orange[400]}
          >
            {'Task Due'}
          </Tag>
        )}

        {hasOverDueTask && (
          <Box
            sx={{
              '@keyframes fade-in-out': {
                '0%': {
                  opacity: 0.5,
                },

                '50%': {
                  opacity: 1,
                },

                '100%': {
                  opacity: 0.5,
                },
              },
              animation: 'fade-in-out 2s ease infinite',
            }}
          >
            <Tag
              backgroundColor={colors.red[100]}
              borderColor={colors.red[400]}
            >
              {'Task Overdue'}
            </Tag>
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default CustomerHeader
